import React, {createContext} from "react"

export type ConfigMode = "vacanceole" | "corseole" | null;

type ConfigContextType = {
    gtm: string,
    mode: ConfigMode
    logo: string,
}

export const ConfigContext = createContext<ConfigContextType>({
    gtm: "",
    mode: null,
    logo: "",
});